import { FC, useState } from 'react';
import assistantService from '@/services/assistant.service';
import { GeneratedFileRef } from '@/types/assistant';

interface Props {
  file: GeneratedFileRef;
}

const ICON_BY_KIND: Record<string, string> = {
  docx: 'description',
  pdf: 'picture_as_pdf',
  xlsx: 'table_chart',
  csv: 'table_chart',
  html: 'html',
  md: 'article',
  png: 'image',
  pptx: 'slideshow', // G15: apresentação
};

function humanSize(bytes?: number): string {
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Chip de arquivo gerado pela H.Bot (G03/G05) — clique baixa via SAS (G10). */
const GeneratedFileChip: FC<Props> = ({ file }) => {
  const [loading, setLoading] = useState(false);
  const icon = ICON_BY_KIND[file.kind?.toLowerCase()] ?? 'draft';
  const size = humanSize(file.size_bytes);

  async function download() {
    if (loading) return;
    setLoading(true);
    try {
      const url = await assistantService.getFileUrl(file.file_id);
      if (url) window.open(url, '_blank', 'noopener');
    } catch {
      /* sem URL — chip vira no-op (admin pode ter desligado Azure) */
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      data-testid="generated-file-chip"
      onClick={download}
      disabled={loading}
      title={`Baixar ${file.filename}`}
      className="inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-lg bg-surface-tertiary border border-surface-border text-content-secondary hover:border-accent hover:text-accent transition disabled:opacity-60"
    >
      <span className="material-symbols-outlined text-base leading-none">
        {loading ? 'progress_activity' : icon}
      </span>
      <span className="max-w-[180px] truncate">{file.filename}</span>
      {size && <span className="text-content-tertiary">· {size}</span>}
      <span className="material-symbols-outlined text-sm leading-none">download</span>
    </button>
  );
};

export default GeneratedFileChip;
